import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../configs/urlConfig"; // tvoj API base URL
import Utils from "../utils";
import Musterije from "../components/Musterije";
import ShowDate from "../components/ShowDate";

axios.defaults.withCredentials = true;

function ByDate() {
  const { date } = useParams(); // uzima datum iz URL-a
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModalDatum, setShowModalDatum] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError("");

        // šaljemo datum u backend
        const response = await axios.get(`${API}/bydate/?date=${date}`, Utils.getUserToken());
        setData(response.data); // pretpostavljam da backend vraća objekat sa poljem "payouts"
      } catch (err) {
        console.error(err);
        setError("Greška prilikom dohvata podataka");
      } finally {
        setLoading(false);
      }
    };

    if (date) {
      fetchData();
    }
  }, [date]);

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        Učitavanje...
      </div>
    );

  if (error)
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <p className="text-danger">{error}</p>
      </div>
    );

  if (!data || !data.payouts)
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <p>Nema podataka</p>
      </div>
    );


  return (
    <div className="container mt-4">
      <div className="mb-4">
        <h2 className="text-primary text-center">
          <strong onClick={() => navigate('/')}>Nazad</strong> | <strong onClick={() => setShowModalDatum(true)}>{data.date_formatted}</strong>
        </h2>
        <p className="text-muted d-flex justify-content-between mb-0">
          <strong>{Utils.formatirajBroj(data.total_amount)} €</strong>

          <strong>{Utils.formatirajBroj(data.total_payout)} €</strong>
        </p>
      </div>

      <Musterije data={data} setData={setData} date={date} />


      <ShowDate

        showModalDatum={showModalDatum}
        setShowModalDatum={setShowModalDatum}
      />
    </div>
  );
}

export default ByDate;